{
  "version": 1,
  "asset_id": "9c53683c-8152-45d1-9ca5-9da66f32e6b2",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/9c53683c-8152-45d1-9ca5-9da66f32e6b2/antiquing-applied.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/9c53683c-8152-45d1-9ca5-9da66f32e6b2/antiquing-applied.mp4",
  "original_filename": "antiquing-applied.mp4",
  "size": 5014420,
  "content_type": "video/mp4",
  "created_at": "2026-09-11T23:20:27Z"
}
